import React from "react";
import Image from "react-bootstrap/Image";
import moment from "moment";

export const TableBodyRefree = ({
  id,
  src,
  userName,
  refree,
  number,
  referralCode,
  used,
  actions,
  refereeRole,
  refuserId,
  referred,
  referalRole,
  refDate,
  selectedTab,
  enrollDate,
  lastActivity,
  referralQualified,
  lastActivityReferree,
  amount,
  receivingOrgID,
  receivingOrgName,
  amountDisburse,
  email,
  status,
  type,
  expire_at,
  url,
}) => {
  return (
    <tr
      className="superadmin-referral-table-body mt-3"
      style={{ wordWrap: "break-word" }}
    >
      {type === 1 ? (
        <>
          <td style={{ width: "10%" }}>
            <div className="f12-500">{id}</div>
          </td>
          <td style={{ width: "10%" }}>{referralCode}</td>
          <td style={{ width: "15%" }}>
            <div className="section-one-box">
              <div className="image-user-box">
                <Image
                  src={referred.src}
                  alt="User Pic"
                  title="refree User"
                  fluid
                />
              </div>
              <h3>{referred.name}</h3>
            </div>
          </td>
          <td style={{ width: "10%" }}>{referalRole}</td>
          <td style={{ width: "15%" }}>
            {moment(enrollDate).format("Do MMM YYYY HH:mm")}
            <br />
            <span style={{ color: "#EE3A23" }}>
              {expire_at && moment(expire_at).format("Do MMM YYYY HH:mm")}
            </span>
          </td>
          <td style={{ width: "10%" }}>{url}</td>
          <td style={{ width: "10%" }}>{status}</td>
          <td style={{ width: "20%" }}>{actions}</td>{" "}
        </>
      ) : (
        <>
          {" "}
          <td style={{ width: "10%" }}>
            <div className="f12-500">{id}</div>
          </td>
          <td style={{ width: "20%" }}>
            <div className="section-one-box">
              <div className="image-user-box">
                <Image
                  src={refree.src}
                  alt="User Pic"
                  title="refree User"
                  fluid
                />
              </div>
              <h3>{refree.name}</h3>
            </div>
          </td>
          <td style={{ width: "15%" }}>{number}</td>
          <td style={{ width: "15%", wordWrap: "break-word" }}>{email}</td>
          <td style={{ width: "10%" }}>{refereeRole}</td>
          <td style={{ width: "10%" }}>{status}</td>
          <td style={{ width: "20%" }}>{actions}</td>
        </>
      )}
    </tr>
  );
};
